/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/AutoCompleteCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { format } from "VSS/Core/Util/String";
import { Components } from "VSS/Platform/Layout";
import { Persona, PersonaSize } from "VSSUI/Persona";
import { getIdentity, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";

export const AutoCompleteCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;
    if (!isShim) {
        const identityId = getPropertyValue(props.thread, "CodeReviewAutoCompleteUpdatedByIdentity");
        const identity = getIdentity(props.thread, identityId);

        let message = "";
        const value = getPropertyValue(props.thread, "CodeReviewAutoCompleteNowSet");
        const failReason = getPropertyValue(props.thread, "CodeReviewAutoCompleteFailedReason");

        if (value === "0") {
            message = Resources.ActivityFeedUnsetAutoComplete;
        } else {
            message = Resources.ActivityFeedSetAutoComplete;
        }

        return (
            <ActivityCardSubtle createDate={props.thread.publishedDate}>
                {!failReason && identity ? (
                    <>
                        <Persona ariaHidden={true} className="activity-card-first-image" identity={identity} size={PersonaSize.size24} />
                        <span>{format(message, identity.displayName)}</span>
                    </>
                ) : (
                    props.thread.comments[0].content
                )}
            </ActivityCardSubtle>
        );
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <ActivityShimmer />
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.auto-complete-activity-card", AutoCompleteCard);
